import { WorkflowFormTemplateRevision } from '../workflow-form-template';
import {
  IWorkflowFormTemplateRevision,
  IWorkflowFormTemplateRevisionData,
  IWorkflowFormTemplateRevisionStatus
} from '../workflow-form-template.types';

export const mockWorkflowFormTemplateRevisionData = (): IWorkflowFormTemplateRevisionData[] => [
  {
    id: 1,
    owner: 'Lamar Falconer',
    state: {
      display_name: 'Draft',
      value: 0
    } as IWorkflowFormTemplateRevisionStatus,
    sections: [
      {
        id: 1,
        title: 'Employee Information',
        order: 1,
        section_fields: [
          {
            id: 1,
            field_template: {
              id: 1,
              label: 'First Name',
              meta_label: 'first_name',
              type: 1,
              options: [],
              hint: ''
            },
            required: true,
            disabled: false,
            create_todo: false,
            order: 1,
            width: 6,
            constraints: []
          },
          {
            id: 2,
            field_template: {
              id: 2,
              label: 'Last Name',
              meta_label: 'last_name',
              type: 1,
              options: [],
              hint: ''
            },
            required: true,
            disabled: false,
            create_todo: false,
            order: 2,
            width: 6,
            constraints: []
          },
          {
            id: 3,
            field_template: {
              id: 3,
              label: 'Title',
              meta_label: 'title',
              type: 1,
              options: [],
              hint: ''
            },
            required: false,
            disabled: false,
            create_todo: false,
            order: 3,
            width: 12,
            constraints: []
          },
          {
            id: 4,
            field_template: {
              id: 4,
              label: 'Department',
              meta_label: 'department',
              type: 3,
              options: [
                {
                  id: 49,
                  value: 'Customer Care',
                  order: 1,
                  field: 4
                },
                {
                  id: 50,
                  value: 'Engineering / R&D',
                  order: 2,
                  field: 4
                },
                {
                  id: 51,
                  value: 'Finance',
                  order: 3,
                  field: 4
                },
                {
                  id: 52,
                  value: 'Global Field Service',
                  order: 4,
                  field: 4
                },
                {
                  id: 53,
                  value: 'Hatchery Consultants',
                  order: 5,
                  field: 4
                },
                {
                  id: 54,
                  value: 'Hatchery solutions',
                  order: 6,
                  field: 4
                },
                {
                  id: 55,
                  value: 'Human Resources',
                  order: 7,
                  field: 4
                },
                {
                  id: 56,
                  value: 'Information Technology',
                  order: 8,
                  field: 4
                },
                {
                  id: 57,
                  value: 'Integrated Planning',
                  order: 9,
                  field: 4
                },
                {
                  id: 58,
                  value: 'Inventory',
                  order: 10,
                  field: 4
                },
                {
                  id: 59,
                  value: 'Logistics',
                  order: 11,
                  field: 4
                },
                {
                  id: 60,
                  value: 'Maintenance',
                  order: 12,
                  field: 4
                },
                {
                  id: 61,
                  value: 'Manufacturing Engineering',
                  order: 13,
                  field: 4
                },
                {
                  id: 62,
                  value: 'Marketing',
                  order: 14,
                  field: 4
                },
                {
                  id: 63,
                  value: 'Operations',
                  order: 15,
                  field: 4
                },
                {
                  id: 64,
                  value: 'Order Management',
                  order: 16,
                  field: 4
                },
                {
                  id: 65,
                  value: 'Procurement',
                  order: 17,
                  field: 4
                },
                {
                  id: 66,
                  value: 'Product Management',
                  order: 18,
                  field: 4
                },
                {
                  id: 67,
                  value: 'Production',
                  order: 19,
                  field: 4
                },
                {
                  id: 68,
                  value: 'Production Planning',
                  order: 20,
                  field: 4
                },
                {
                  id: 69,
                  value: 'Project management',
                  order: 21,
                  field: 4
                },
                {
                  id: 70,
                  value: 'Quality',
                  order: 22,
                  field: 4
                },
                {
                  id: 71,
                  value: 'Sales',
                  order: 23,
                  field: 4
                },
                {
                  id: 72,
                  value: 'HVAC Engineering / Vent',
                  order: 24,
                  field: 4
                }
              ],
              hint: ''
            },
            required: false,
            disabled: false,
            create_todo: false,
            order: 4,
            width: 12,
            constraints: []
          },
          {
            id: 9,
            field_template: {
              id: 10,
              label: 'Employee Type',
              meta_label: 'type',
              type: 3,
              options: [
                {
                  id: 5,
                  value: 'Salary',
                  order: 3,
                  field: 10
                },
                {
                  id: 6,
                  value: 'Salary Contract',
                  order: 4,
                  field: 10
                },
                {
                  id: 7,
                  value: 'Temp Agency',
                  order: 5,
                  field: 10
                },
                {
                  id: 8,
                  value: 'Co Op',
                  order: 6,
                  field: 10
                },
                {
                  id: 9,
                  value: 'Part Time',
                  order: 7,
                  field: 10
                }
              ],
              hint: ''
            },
            required: false,
            disabled: false,
            create_todo: false,
            order: 5,
            width: 12,
            constraints: []
          },
          {
            id: 5,
            field_template: {
              id: 6,
              label: 'Expected Start Date',
              meta_label: 'hire_date',
              type: 6,
              options: [],
              hint: ''
            },
            required: false,
            disabled: false,
            create_todo: false,
            order: 6,
            width: 6,
            constraints: []
          },
          {
            id: 6,
            field_template: {
              id: 7,
              label: 'Expected End Date',
              meta_label: 'expected_end_date',
              type: 6,
              options: [],
              hint:
                '(Only if you choose Co-Op, Contract, Temp agency form the employee type)'
            },
            required: false,
            disabled: false,
            create_todo: false,
            order: 7,
            width: 6,
            constraints: []
          },
          {
            id: 7,
            field_template: {
              id: 8,
              label: 'Working Location',
              meta_label: 'work_location',
              type: 3,
              options: [
                {
                  id: 37,
                  value: 'Cambridge Office',
                  order: 1,
                  field: 8
                },
                {
                  id: 38,
                  value: 'Medina Office/Warehouse',
                  order: 2,
                  field: 8
                },
                {
                  id: 39,
                  value: 'UK Office',
                  order: 3,
                  field: 8
                },
                {
                  id: 40,
                  value: 'Remote (Please enter home address below)',
                  order: 4,
                  field: 8
                }
              ],
              hint: ''
            },
            required: false,
            disabled: false,
            create_todo: false,
            order: 8,
            width: 12,
            constraints: []
          },
          {
            id: 36,
            field_template: {
              id: 37,
              label: 'Contract',
              meta_label: '',
              type: 7,
              options: [],
              hint: ''
            },
            required: false,
            disabled: false,
            create_todo: false,
            order: 8,
            width: 12,
            constraints: []
          },
          {
            id: 8,
            field_template: {
              id: 9,
              label: 'Home Address',
              meta_label: 'home_address',
              type: 2,
              options: [],
              hint: 'If Remote, please enter home address'
            },
            required: false,
            disabled: false,
            create_todo: false,
            order: 9,
            width: 12,
            constraints: []
          }
        ]
      },
      {
        id: 2,
        title: 'Hardware Setup',
        order: 2,
        section_fields: [
          {
            id: 10,
            field_template: {
              id: 11,
              label: 'Computer Requirements',
              meta_label: 'computer_requirements',
              type: 3,
              options: [
                {
                  id: 41,
                  value: 'Standard desktop',
                  order: 1,
                  field: 11
                },
                {
                  id: 42,
                  value: 'Standard laptop small screen (12")',
                  order: 2,
                  field: 11
                },
                {
                  id: 43,
                  value: 'Standard laptop large screen (15")',
                  order: 3,
                  field: 11
                },
                {
                  id: 44,
                  value: 'Advanced Workstation (SolidWorks)',
                  order: 4,
                  field: 11
                },
                {
                  id: 45,
                  value: 'High performance laptop',
                  order: 5,
                  field: 11
                },
                {
                  id: 46,
                  value: 'Tablet small screen (13")',
                  order: 6,
                  field: 11
                },
                {
                  id: 47,
                  value: 'Tablet large screen (15")',
                  order: 7,
                  field: 11
                },
                {
                  id: 48,
                  value: 'No Computer Required',
                  order: 8,
                  field: 11
                }
              ],
              hint: ''
            },
            required: false,
            disabled: false,
            create_todo: false,
            order: 1,
            width: 12,
            constraints: []
          },
          {
            id: 11,
            field_template: {
              id: 12,
              label:
                'Additional computer requirements for Remote Employees (subject to approval):',
              meta_label: 'additional_computer_requirements',
              type: 4,
              options: [
                {
                  id: 10,
                  value: 'Dock for home office (Remote)',
                  order: 1,
                  field: 12
                },
                {
                  id: 11,
                  value: 'Monitor for home office (Remote)',
                  order: 2,
                  field: 12
                }
              ],
              hint: ''
            },
            required: false,
            disabled: false,
            create_todo: false,
            order: 2,
            width: 12,
            constraints: []
          },
          {
            id: 12,
            field_template: {
              id: 13,
              label: 'Phone requirements (check all that apply):',
              meta_label: 'phone_requirements',
              type: 4,
              options: [
                {
                  id: 12,
                  value: 'Desk phone',
                  order: 1,
                  field: 13
                },
                {
                  id: 13,
                  value: 'Cell Phone',
                  order: 2,
                  field: 13
                },
                {
                  id: 14,
                  value: 'Portable phone',
                  order: 3,
                  field: 13
                },
                {
                  id: 15,
                  value: 'No phone',
                  order: 4,
                  field: 13
                }
              ],
              hint: ''
            },
            required: false,
            disabled: false,
            create_todo: true,
            order: 3,
            width: 12,
            constraints: []
          },
          {
            id: 13,
            field_template: {
              id: 14,
              label: 'Any other requirements?',
              meta_label: 'other_phone_requirements',
              type: 1,
              options: [],
              hint: ''
            },
            required: false,
            disabled: false,
            create_todo: false,
            order: 4,
            width: 12,
            constraints: []
          }
        ]
      },
      {
        id: 3,
        title: 'Software Setup',
        order: 3,
        section_fields: [
          {
            id: 14,
            field_template: {
              id: 15,
              label: 'JCMI Email Required:',
              meta_label: 'email_required',
              type: 5,
              options: [
                {
                  id: 16,
                  value: 'Yes',
                  order: 1,
                  field: 15
                },
                {
                  id: 17,
                  value: 'No',
                  order: 2,
                  field: 15
                }
              ],
              hint: ''
            },
            required: false,
            disabled: false,
            create_todo: false,
            order: 1,
            width: 12,
            constraints: []
          },
          {
            id: 15,
            field_template: {
              id: 16,
              label:
                'Is there an existing person we can use to copy their profile for the new person:',
              meta_label: 'existing_person_profile',
              type: 1,
              options: [],
              hint: ''
            },
            required: false,
            disabled: false,
            create_todo: false,
            order: 2,
            width: 12,
            constraints: []
          },
          {
            id: 16,
            field_template: {
              id: 17,
              label:
                'Standard applications: Microsoft Outlook, Adobe Acrobat Reader, Greenshot (screen capture), Docova (if role suggests), Excel/Word/PowerPoint, Microsoft Teams, Carbon Black, Antivirus, Omnify (bookmark), Microsoft OneDrive, Cisco VPN client (for laptops), 7-Zip (for zipped files), Keep and Share (bookmark)',
              meta_label: '',
              type: 0,
              options: [],
              hint: ''
            },
            required: false,
            disabled: false,
            create_todo: false,
            order: 3,
            width: 12,
            constraints: []
          },
          {
            id: 17,
            field_template: {
              id: 18,
              label:
                'Other required software (please check any / all that apply):',
              meta_label: 'other_required_software',
              type: 4,
              options: [
                {
                  id: 18,
                  value: 'SolidWorks',
                  order: 1,
                  field: 18
                },
                {
                  id: 19,
                  value: 'Zoho',
                  order: 2,
                  field: 18
                },
                {
                  id: 20,
                  value: 'PDM client / access',
                  order: 2,
                  field: 18
                },
                {
                  id: 21,
                  value: 'Acrobat (full version, ability to edit PDF files)',
                  order: 4,
                  field: 18
                },
                {
                  id: 22,
                  value: 'Smart Draw',
                  order: 5,
                  field: 18
                },
                {
                  id: 23,
                  value: 'PLM',
                  order: 6,
                  field: 18
                },
                {
                  id: 24,
                  value: 'CSI',
                  order: 7,
                  field: 18
                }
              ],
              hint: ''
            },
            required: false,
            disabled: false,
            create_todo: false,
            order: 4,
            width: 12,
            constraints: []
          },
          {
            id: 18,
            field_template: {
              id: 19,
              label: 'Any other applications not mentioned here:',
              meta_label: 'other_applications',
              type: 1,
              options: [],
              hint: ''
            },
            required: false,
            disabled: false,
            create_todo: false,
            order: 5,
            width: 12,
            constraints: []
          }
        ]
      },
      {
        id: 4,
        title: 'Jamesway Portal Setup',
        order: 4,
        section_fields: [
          {
            id: 19,
            field_template: {
              id: 20,
              label: 'Jamesway Portal setup:',
              meta_label: 'portal_setup',
              type: 4,
              options: [
                {
                  id: 25,
                  value: 'Purchase Requisitions',
                  order: 1,
                  field: 20
                },
                {
                  id: 26,
                  value: 'Payment Requisitions',
                  order: 2,
                  field: 20
                },
                {
                  id: 27,
                  value:
                    'Payroll Change Requests (for shop floor supervisors only)',
                  order: 3,
                  field: 20
                },
                {
                  id: 28,
                  value: 'Time-Off Application',
                  order: 4,
                  field: 20
                }
              ],
              hint: ''
            },
            required: false,
            disabled: false,
            create_todo: false,
            order: 1,
            width: 12,
            constraints: []
          },
          {
            id: 24,
            field_template: {
              id: 25,
              label: 'Will this person be an approver in Purchase Requisition',
              meta_label: '',
              type: 5,
              options: [
                {
                  id: 35,
                  value: 'Yes',
                  order: 1,
                  field: 25
                },
                {
                  id: 36,
                  value: 'No',
                  order: 2,
                  field: 25
                }
              ],
              hint: ''
            },
            required: false,
            disabled: false,
            create_todo: false,
            order: 2,
            width: 12,
            constraints: []
          },
          {
            id: 26,
            field_template: {
              id: 27,
              label:
                'Will this person be an approver for anyone in Time-off Application?',
              meta_label: '',
              type: 5,
              options: [
                {
                  id: 73,
                  value: 'Yes',
                  order: 1,
                  field: 27
                },
                {
                  id: 74,
                  value: 'No',
                  order: 2,
                  field: 27
                }
              ],
              hint: ''
            },
            required: false,
            disabled: false,
            create_todo: false,
            order: 3,
            width: 12,
            constraints: []
          },
          {
            id: 27,
            field_template: {
              id: 28,
              label: 'If yes, who will they be approver for?',
              meta_label: 'approver_personnel',
              type: 1,
              options: [],
              hint: ''
            },
            required: false,
            disabled: false,
            create_todo: false,
            order: 4,
            width: 12,
            constraints: []
          }
        ]
      },
      {
        id: 5,
        title: 'Rydoo Setup',
        order: 5,
        section_fields: [
          {
            id: 20,
            field_template: {
              id: 21,
              label: 'Rydoo setup:',
              meta_label: 'rydoo_setup',
              type: 5,
              options: [
                {
                  id: 29,
                  value: 'Yes',
                  order: 1,
                  field: 21
                },
                {
                  id: 30,
                  value: 'No',
                  order: 2,
                  field: 21
                }
              ],
              hint: ''
            },
            required: false,
            disabled: false,
            create_todo: false,
            order: 1,
            width: 12,
            constraints: []
          },
          {
            id: 25,
            field_template: {
              id: 26,
              label: 'If yes, Department Code',
              meta_label: 'code',
              type: 1,
              options: [],
              hint: ''
            },
            required: false,
            disabled: false,
            create_todo: false,
            order: 2,
            width: 6,
            constraints: []
          },
          {
            id: 21,
            field_template: {
              id: 22,
              label: 'Payment Currency:',
              meta_label: 'payment_currency',
              type: 1,
              options: [],
              hint: ''
            },
            required: false,
            disabled: false,
            create_todo: false,
            order: 3,
            width: 6,
            constraints: []
          },
          {
            id: 22,
            field_template: {
              id: 23,
              label: 'Will this person be an approver for anyone in Rydoo?',
              meta_label: 'approver_personnel',
              type: 5,
              options: [
                {
                  id: 31,
                  value: 'Yes',
                  order: 1,
                  field: 23
                },
                {
                  id: 32,
                  value: 'No',
                  order: 2,
                  field: 23
                }
              ],
              hint: ''
            },
            required: false,
            disabled: false,
            create_todo: false,
            order: 3,
            width: 12,
            constraints: []
          },
          {
            id: 23,
            field_template: {
              id: 24,
              label: 'If yes, who will they be approver for?',
              meta_label: 'approver_personnel',
              type: 1,
              options: [],
              hint: ''
            },
            required: false,
            disabled: false,
            create_todo: false,
            order: 3,
            width: 12,
            constraints: []
          }
        ]
      }
    ],
    created_at: '2023-04-17T14:21:09.016000Z',
    updated_at: '2023-04-17T14:21:09.016000Z'
  },
  {
    id: 2,
    owner: 'Lamar Falconer',
    state: {
      display_name: 'Draft',
      value: 0
    } as IWorkflowFormTemplateRevisionStatus,
    sections: [
      {
        id: 6,
        title: 'Employee Information',
        order: 1,
        section_fields: [
          {
            id: 28,
            field_template: {
              id: 29,
              label: 'First Name',
              meta_label: 'first_name',
              type: 1,
              options: [],
              hint: ''
            },
            required: false,
            disabled: false,
            create_todo: false,
            order: 1,
            width: 6,
            constraints: []
          },
          {
            id: 37,
            field_template: {
              id: 1,
              label: 'First Name',
              meta_label: 'first_name',
              type: 1,
              options: [],
              hint: ''
            },
            required: false,
            disabled: false,
            create_todo: false,
            order: 1,
            width: 12,
            constraints: []
          },
          {
            id: 29,
            field_template: {
              id: 30,
              label: 'Last Name',
              meta_label: 'last_name',
              type: 1,
              options: [],
              hint: ''
            },
            required: false,
            disabled: false,
            create_todo: false,
            order: 2,
            width: 6,
            constraints: []
          },
          {
            id: 30,
            field_template: {
              id: 31,
              label: 'Department',
              meta_label: 'department',
              type: 1,
              options: [],
              hint: ''
            },
            required: false,
            disabled: false,
            create_todo: false,
            order: 2,
            width: 12,
            constraints: []
          },
          {
            id: 31,
            field_template: {
              id: 32,
              label: 'Last Day',
              meta_label: 'Last Day',
              type: 6,
              options: [],
              hint: ''
            },
            required: false,
            disabled: false,
            create_todo: false,
            order: 3,
            width: 12,
            constraints: []
          },
          {
            id: 32,
            field_template: {
              id: 33,
              label: 'Forward email to',
              meta_label: 'Forward email to',
              type: 1,
              options: [],
              hint: ''
            },
            required: false,
            disabled: false,
            create_todo: false,
            order: 4,
            width: 12,
            constraints: []
          },
          {
            id: 33,
            field_template: {
              id: 34,
              label: 'Give email file access to',
              meta_label: 'Give email file access to',
              type: 1,
              options: [],
              hint: ''
            },
            required: false,
            disabled: false,
            create_todo: false,
            order: 5,
            width: 12,
            constraints: []
          },
          {
            id: 34,
            field_template: {
              id: 35,
              label: 'Give file / folder / home drive access to',
              meta_label: '',
              type: 1,
              options: [],
              hint: ''
            },
            required: false,
            disabled: false,
            create_todo: false,
            order: 6,
            width: 12,
            constraints: []
          }
        ]
      },
      {
        id: 7,
        title: 'Software',
        order: 2,
        section_fields: [
          {
            id: 35,
            field_template: {
              id: 36,
              label: 'Disable all user accounts',
              meta_label: 'Access_Disabled',
              type: 5,
              options: [
                {
                  id: 75,
                  value: 'Yes',
                  order: 1,
                  field: 36
                }
              ],
              hint: ''
            },
            required: false,
            disabled: false,
            create_todo: false,
            order: 1,
            width: 12,
            constraints: []
          }
        ]
      }
    ],
    created_at: '2023-04-26T14:48:35.852182Z',
    updated_at: '2023-04-26T14:48:39.915532Z'
  },
  {
    id: 3,
    owner: 'Lamar Falconer',
    state: {
      display_name: 'Draft',
      value: 0
    } as IWorkflowFormTemplateRevisionStatus,
    sections: [],
    created_at: '2023-07-11T18:57:11.621654Z',
    updated_at: '2023-07-11T18:57:11.621703Z'
  }
];

export const mockWorkflowFormTemplateRevisions = (
  data: IWorkflowFormTemplateRevisionData[] = mockWorkflowFormTemplateRevisionData()
): IWorkflowFormTemplateRevision[] =>
  data.map(item => new WorkflowFormTemplateRevision(item));
